module.exports = __webpack_public_path__ + "assets/img/61ee3aa49c51afeac39653b33a93f348.svg";